import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { filter, switchMap, take, tap } from 'rxjs/operators'
import { AuthService } from 'src/app/login/services/auth.service'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor (public authService: AuthService, public router: Router) {}

  public canActivate (): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.initialized$.pipe(
      filter((init) => init), // wait for initialization
      take(1),
      switchMap(() => this.authService.isLoggedIn$),
      take(1),
      tap((loggedIn) => {
        if (!loggedIn) {this.router.navigate(['login'])}
      })
    )
  }
}
